import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4a4b69c2")
const _hoisted_1 = {
  key: 0,
  class: "flex items_center justify_center loader-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "last-step__wrapper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text_centered" }, "Последний этап", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text_centered plain-text" }, "Отправить тестовое задание на рассмотрение?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "last-step__white-space" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Вернуться назад")
const _hoisted_7 = {
  key: 2,
  class: "last-step__wrapper"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text_centered" }, "Готово", -1)
const _hoisted_9 = { class: "text_centered plain-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text_centered plain-text" }, "Если же Вы получили задание самостоятельно, то на обработку отводится до 10 дней. Если за это время с Вами не вышли на связь, то вы провалили тестирование.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "last-step__white-space" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://bekhan.org",
  class: "last-step__submit-button"
}, "На главную страницу", -1)
const _hoisted_13 = {
  key: 0,
  class: "plain-text text_centered"
}
const _hoisted_14 = ["href", "download"]
const _hoisted_15 = {
  key: 3,
  class: "last-step__wrapper"
}
const _hoisted_16 = { class: "text_centered" }
const _hoisted_17 = { class: "text_centered plain-text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "last-step__white-space" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThePreloader = _resolveComponent("ThePreloader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ThePreloader)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.isFinished === false && !_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("button", {
            class: "last-step__submit-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.publish()))
          }, "Да, отправить"),
          _createVNode(_component_router_link, {
            class: "micro text_secondary text_centered",
            to: "/test"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFinished && !_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, "Если тестовое задание выдал наш сотрудник, то оповестите его о выполнении. Ваш ID: " + _toDisplayString(_ctx.userID), 1),
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("a", {
            class: "text_centered micro text_secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadResults()))
          }, "Скачать свое задание"),
          (_ctx.pdfLink)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Если ничего не произошло - проверьте папку загрузок или нажмите на ссылку:"))
            : _createCommentVNode("", true),
          (_ctx.pdfLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.pdfLink,
                class: "micro text_secondary text_centered",
                target: "_blank",
                download: {'Тестовое_IsuAd.pdf' : _ctx.isIOS}
              }, "Тестовое_IsuAd.pdf", 8, _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.errorMessage && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.errorMessage.title), 1),
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.errorMessage.message), 1),
          _hoisted_18,
          (_ctx.errorMessage.again === true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "last-step__submit-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.publish()))
              }, "Попробовать еще раз"))
            : _createCommentVNode("", true),
          (_ctx.errorMessage.again === true)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "micro text_centered text_secondary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.turnBackToTest()))
              }, "Назад"))
            : _createCommentVNode("", true),
          (_ctx.errorMessage.again === false)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "last-step__submit-button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetConnectionError()))
              }, "Назад"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}